import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTextFieldComp from "../../../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../../newComponent/AutocompleteComp";
import CustomSnackbar from "../../../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../../../utils/token";
import useEnhancedEffect from "@mui/utils/useEnhancedEffect";
import { set } from "date-fns";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function AddMetaCampaignForm() {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");

  const [faceBookCampaignName, setFacebookCampaignName] = useState(null);
  const [metaName, setMetaName] = useState(null);
  const [stmCampaignList, setStmCampaignList] = useState([]);
  const [stmCampaign, setStmCampaign] = useState(null);
  const [subServiceKey, setSubServiceKey] = useState(null);

  const [subServiceKeyList, setSubServiceKeyList] = useState([]);
  const [loadingcampaign, setLoadingCampaign] = useState(false);

  const [otherKeyName, setOtherKeyName] = useState(null);
  const [keyForNote, setKeyForNote] = useState(null);
  const [keyForNoteArray, setKeyForNoteArray] = useState([]);
  const [service, setService] = useState(null);
  const [subservice, setSubService] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [suberviceList, setSubServiceList] = useState([]);
  const [programList, setProgramList] = useState([]);
  const [programname, setProgramName] = useState(null);
  const [iskeyOption, setIsKeyOption] = useState(true);
  const [errors, setErrors] = useState({
    faceBookCampaignName: "",
    stmCampaign: "",

    otherKeyName: "",
  });
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  console.log("iskeyoption", iskeyOption);

  const fetchRunningCampaigns = async () => {
    setLoadingCampaign(true);

    let headers = {
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),

      campaign_type_id: [2],
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}campaign/running-campaigns`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setStmCampaignList(result);

        setLoadingCampaign(false);
      } else if (response.status === 401) {
        console.error("unathorized:", "error");
        setLoadingCampaign(false);
      } else {
        console.error("Error sending data:", "error");
        setLoadingCampaign(false);
      }
    } catch (error) {
      console.error("Error sending data:", error);
      setLoadingCampaign(false);
    }
  };

  useEffect(() => {
    fetchRunningCampaigns();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}meta-subservice-key`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setSubServiceKeyList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setServiceList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const fetchSubservices = async () => {
    let headers = {
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),

      service_id: [service?.id],
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/getsubservicebyservice`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setSubServiceList(result);
      } else if (response.status === 401) {
        console.error("unathorized:", "error");
      } else {
        console.error("Error sending data:", "error");
      }
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  useEffect(() => {
    fetchSubservices();
  }, [service]);

  const fetchProgramBySubservices = async () => {
    let headers = {
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),

      sub_service_id: [subservice?.id],
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/getprogramsbysubservice`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setProgramList(result);
      } else if (response.status === 401) {
        console.error("unathorized:", "error");
      } else {
        console.error("Error sending data:", "error");
      }
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  useEffect(() => {
    fetchProgramBySubservices();
  }, [subservice]);

  const handleChangeStmcampaign = (e, value) => {
    setStmCampaign(value);
    setErrors({ ...errors, stmCampaign: !value });
  };

  const allSubServiceKey = [{ name: "Other" }, ...subServiceKeyList];

  const handleChangSubServiceKey = (e, value) => {
    setSubServiceKey(value);
    setOtherKeyName(null);
  };

  const handleChangeService = (e, value) => {
    setSubService(null);
    setProgramName(null);
    setService(value);

  };

  const handleChangeProgram = (e, value) => {
    setProgramName(value);
  };

  const handleChangeSubService = (e, value) => {
    setProgramName(null);
    setSubService(value);
  };

  const handleKeyOption = (event) => {
    setSubServiceKey(null);
    setService(null);
    setSubService(null);
    setOtherKeyName(null);
    setIsKeyOption(event.target.value === "true");
  };

  // Post Data
  const handleSubmit = async (event) => {
    if (
      !faceBookCampaignName ||
      !metaName ||
      !stmCampaign ||
      (iskeyOption && !subServiceKey) ||
      (!iskeyOption && !subservice) ||
      (!iskeyOption && !service) ||
      (subServiceKey?.name === "Other" && !otherKeyName)
    ) {
      setErrors({
        faceBookCampaignName: !faceBookCampaignName,
        metaName: !metaName,
        stmCampaign: !stmCampaign,
        subServiceKey: iskeyOption && !subServiceKey,
        service: !iskeyOption && !service,
        subservice: !iskeyOption && !subservice,
        otherKeyName: subServiceKey?.name === "Other" && !otherKeyName,
      });
      return;
    }

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),
      name: faceBookCampaignName,
      meta_form_name: metaName, 
      stm_campaign: stmCampaign?.id,
      is_key_option: iskeyOption,
      sub_service_key_id:
        subServiceKey?.name === "Other" ? null : subServiceKey?.id,
      other: otherKeyName,
      service_id: service?.id,
      sub_service_id: subservice?.id,
      key_for_note: keyForNote,

    };

    console.log("formdata", formdata);
    try {
      const response = await fetch(`${API_ENDPOINT}facebook-campaign`, {
        method: "POST",
        headers,
        body: JSON.stringify(formdata),
      });

      const result = await response.json();

      if (response.ok) {
        showSnackbar("Enquiry Updated Successfully");

        showSnackbar("Enquiry updated Successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar(result.message, "error");
      }
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h6">
            Facebook Campaign Name{" "}
            <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
          </Typography>
          <CustomTextFieldComp
            size="normal"
            value={faceBookCampaignName}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
            onChange={(e) => {
              const newValue = e.target.value;
              setFacebookCampaignName(newValue);
              setErrors({ ...errors, faceBookCampaignName: !newValue });
            }}
          />
          {errors.faceBookCampaignName && (
            <Typography color="error" variant="caption">
              This is required field
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h6">
            Meta Form Name{" "}
            <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
          </Typography>
          <CustomTextFieldComp
            size="normal"
            value={metaName}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
            onChange={(e) => {
              const newValue = e.target.value;
              setMetaName(newValue);
              setErrors({ ...errors, metaName: !newValue });
            }}
          />
          {errors.metaName && (
            <Typography color="error" variant="caption">
              This is required field
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h6">
            Associated Stm Campaign{" "}
            <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
          </Typography>
          <CustomAutocompleteComp
            size="small"
            disablePortal
            value={stmCampaign}
            options={stmCampaignList}
            getOptionLabel={(option) => option.campaign_name}
            onChange={handleChangeStmcampaign}
          />
          {errors.stmCampaign && (
            <Typography color="error" variant="caption">
              This is required field
            </Typography>
          )}
        </Grid>

        <Grid item xs={12}>
          <RadioGroup
            row
            aria-label="paymentOption"
            value={iskeyOption}
            onChange={handleKeyOption}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label={<Typography variant="h5">Select Key</Typography>}
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              style={{ marginLeft: 2 }}
              label={<Typography variant="h5">Select Sub Service</Typography>}
              // disabled={!isInstallmentAvailable()}
            />
          </RadioGroup>
        </Grid>

        {iskeyOption && (
          <>
            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="h6">
                Sub Service key{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>

              <CustomAutocompleteComp
                size="small"
                disablePortal
                value={subServiceKey}
                options={allSubServiceKey}
                getOptionLabel={(option) => option.name}
                onChange={handleChangSubServiceKey}
              />
              {errors.subServiceKey && (
                <Typography color="error" variant="caption">
                  This is required field
                </Typography>
              )}
            </Grid>
            {subServiceKey?.name === "Other" && (
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="h6">
                  {" "}
                  Add Sub Service Key{" "}
                  <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
                </Typography>
                <CustomTextFieldComp
                  size="normal"
                  value={otherKeyName}
                  InputProps={{
                    style: { borderRadius: "10px" },
                  }}
                  fullWidth
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setOtherKeyName(newValue);
                    setErrors({ ...errors, subServiceKey: !newValue });
                  }}
                />
                {errors.otherKeyName && (
                  <Typography color="error" variant="caption">
                    This is required field
                  </Typography>
                )}
              </Grid>
            )}
          </>
        )}

        {!iskeyOption && (
          <>
            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="h6">
                Select Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <CustomAutocompleteComp
                size="small"
                disablePortal
                value={service}
                options={serviceList}
                getOptionLabel={(option) => option.service_name}
                onChange={handleChangeService}
              />
              {errors.service && (
                <Typography color="error" variant="caption">
                  This is required field
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="h6">
                Select Sub Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <CustomAutocompleteComp
                size="small"
                disablePortal
                noOptionsText={
                  service === null ? "Please Select Service First" : ""
                }
                value={subservice}
                options={suberviceList}
                getOptionLabel={(option) => option.name}
                onChange={handleChangeSubService}
              />
              {errors.subservice && (
                <Typography color="error" variant="caption">
                  This is required field
                </Typography>
              )}
            </Grid>

            {(subservice?.name === "Scholars Undergraduate Admission Program" ||
              subservice?.name ===
                "⁠Scholars Postgraduate Admission Program") && (
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="h6">Select Program</Typography>
                <CustomAutocompleteComp
                  size="small"
                 
                  noOptionsText={
                    subservice === null ? "Please Select Sub Service First" : ""
                  }
                  value={programname}
                  options={programList}
                  getOptionLabel={(option) => option.name}
                  onChange={handleChangeProgram}
                />
              </Grid>
            )}
          </>
        )}


         <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h6">
           Add Keys For Create Note
          </Typography>

          <CustomTextFieldComp
            size="normal"
            value={keyForNote}
            InputProps={{
             style: { borderRadius: "10px" },
            }}
            fullWidth
            onChange={(e) => {
            const newValue = e.target.value;

            // keep string for input
            setKeyForNote(newValue);

            // convert to array
            const keyArray = newValue
              .split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "");

              setKeyForNoteArray(keyArray);
    }}
  />
</Grid>

        <Grid item xs={12} textAlign="end">
          <Button variant="contained" color="secondary" onClick={handleSubmit}>
            Submit
          </Button>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
